import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAppGroupIdLibraryReplaceFileCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/media_library_tags",
  "/engagement/:app_group_id/media_library_territories",
  "/engagement/media_library_data",
  "/engagement/:app_group_id/media_library_asset_data/:asset_id",
];
